/**
 * Polyfills da aplicação, carregados antes do main.ts.
 * O zone.js é injetado pela opção "polyfills" do angular.json.
 */

// Algumas dependências (ex.: sockjs/stomp legados) esperam o objeto `global` do Node.
(window as any).global = window;

